import { makeObservable, observable, action, runInAction } from "mobx";
import { apiFetch } from "../config/api";
import { toast } from "react-toastify";

class InvoiceStore {
  specificInvoice = {};
  invoicePreviewUrl = "";

  isLoadingSpecificInvoice = false;

  constructor() {
    makeObservable(this, {
      specificInvoice: observable.ref,
      isLoadingSpecificInvoice: observable.ref,
      invoicePreviewUrl: observable.ref,

      getSpecificInvoice: action,
      updateInvoice: action,
      generateInvoicePDF: action,
      previewInvoicePDF: action,
    });
  }

  getSpecificInvoice = ({guid, callback}) => {
    runInAction(() => {
      this.isLoadingSpecificInvoice = true;
    });
    apiFetch(`api/invoice/${guid}/`)
      .then(({ data }) => {
        runInAction(() => {
          this.specificInvoice = data;
          callback && callback(data?.id)
          this.isLoadingSpecificInvoice = false;
        });
      })
      .catch((error) => {
        runInAction(() => {
          this.isLoadingSpecificInvoice = false;
          toast.error("Failed to fetch invoice details.");
        });
      });
  };

  updateInvoice = ({ guid, payload, onSuccess }) => {
    runInAction(() => {
      this.isLoadingSpecificInvoice = true;
    });
    const hasAccessToken = Boolean(localStorage.getItem("access_token"));
    const requestPayload = {
      accepted: payload?.accepted === true,
    };
    const endpoint = hasAccessToken
      ? `api/invoices/${guid}/update-estimate-status/`
      : `api/invoice/${guid}/approve/`;

    return apiFetch(endpoint, {
      method: "POST",
      body: requestPayload,
    })
      .then(({ data }) => {
        runInAction(() => {
          this.specificInvoice.job.estimate_accepted = true;
          this.isLoadingSpecificInvoice = false;
          toast.success(data.message);
        });
        onSuccess && onSuccess();
      })
      .catch((error) => {
        runInAction(() => {
          this.isLoadingSpecificInvoice = false;
          toast.error(
            error?.response?.data?.error || "Failed to update Invoice."
          );
        });
        throw error;
      });
  };

  generateInvoicePDF = ({ invoice_id }) => {
    apiFetch(`generate-invoice/${invoice_id}/`, {
      responseType: "blob",
    })
      .then(({ data, headers }) => {
        const disposition = headers?.["content-disposition"] || "";
        const match = disposition.match(/filename="?([^"]+)"?/i);
        const filename = match?.[1] || `invoice_${invoice_id}.pdf`;
        const url = window.URL.createObjectURL(data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        toast.success("Invoice PDF Successfully Downloaded.");
      })
      .catch((error) => {
        runInAction(() => {
          toast.error("Failed to Download Invoice PDF.");
        });
      });
  };

  previewInvoicePDF = ({ invoice_id }) => {
    apiFetch(`generate-invoice/${invoice_id}/`, {
      responseType: "blob",
    })
      .then(({ data }) => {
        const blobUrl = window.URL.createObjectURL(data);

        runInAction(() => {
          this.invoicePreviewUrl = blobUrl;
        });
      })
      .catch((error) => {
        runInAction(() => {
          toast.error("Failed to Preview Invoice PDF.");
        });
      });
  };
}

export default new InvoiceStore();
